import { ActionCreatorWithPayload } from "@reduxjs/toolkit";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { canUseDOM } from "web/script/utils/browser/can-use-dom";

export function useInitialReduxState(actions: [ActionCreatorWithPayload<any>, any][]): void {
    // THIS is a temporary work around until we can render components in a single react root
    const dispatch = useDispatch();

    useEffect(() => {
        actions?.map(([action, state]) => {
            dispatch(action(state));
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!canUseDOM()) {
        actions?.map(([action, state]) => {
            dispatch(action(state));
        });
    }
}
